// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.user-status {
  padding: 20px 0 20px;
  text-align: center;
}
.user-status i {
  font-size: 50px;
}
.user-status a {
  align-items: center;
  display: inline-flex;
  vertical-align: middle;
}

footer {
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  background: hsl(0, 0%, 95%);
  bottom: 0;
  left: 0;
  padding: 20px;
  position: absolute;
  text-align: center;
  width: 100%;
}

.popup-header {
  padding: 30px;
  position: relative;
}
.popup-header h2 {
  font-size: 30px;
  font-weight: normal;
  margin: 0;
  outline: none;
  padding: 0;
}

.popup-body {
  padding: 0 30px 20px;
}
.popup-body hr {
  margin: 20px 0;
}
.popup-body h2 {
  font-size: 30px;
  margin-bottom: 20px;
}
.popup-body .current-prod {
  margin-bottom: 10px;
}
.popup-body .form-group {
  margin-bottom: 0;
}
.popup-body .assign-prod label {
  margin-bottom: 5px;
}
.popup-body .prod-desc {
  padding-right: 5px;
}
.popup-body .new {
  width: 100%;
}
.popup-body .text-danger {
  margin-bottom: 0;
}

.popup-footer {
  border-radius: 8px;
  bottom: 0;
  padding: 0 30px;
  position: relative;
  width: 100%;
}
.popup-footer .btn-click {
  float: right;
  margin-left: 30px;
}
.popup-footer hr {
  margin: 30px 0 20px;
}
.popup-footer a {
  margin-bottom: 20px;
}

@media (max-width: 1024px) {
  footer {
    background: none;
    margin-left: 0;
    margin-right: 0;
    padding: 10px;
  }
  footer button {
    background: none !important;
    border: 0 !important;
    box-shadow: none !important;
  }
  .show-sm {
    border: 1px dashed #d2d2d2;
  }
  .btn {
    width: 100%;
  }
  .popup-header {
    padding: 15px 15px 30px;
  }
  .popup-header h2 {
    font-size: 18px;
  }
  .popup-body {
    max-height: 145px;
    overflow: auto;
    padding: 0 15px;
  }
  .popup-body h2 {
    font-size: 18px;
  }
  .popup-footer {
    background: white;
    padding: 0 15px;
  }
  .popup-footer hr {
    margin: 20px 0;
  }
  .popup-footer a {
    margin-top: 20px;
  }
}
.hide {
  display: none;
}

.disabled {
  padding-bottom: 20px;
}

.on-disable {
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/licenses-card/licenses-card.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AA9IA;EACE,oBAAA;EAEA,kBAAA;AA+IF;AA7IE;EACE,eAAA;AA+IJ;AA5IE;EACE,mBAAA;EACA,oBAAA;EACA,sBAAA;AA8IJ;;AA1IA;EFeI,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EEbF,2BAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAiJF;;AA7IA;EACE,aAAA;EACA,kBAAA;AAgJF;AA9IE;EACE,eAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;AAgJJ;;AA5IA;EACE,oBAAA;AA+IF;AA7IE;EACE,cAAA;AA+IJ;AA5IE;EACE,eAAA;EACA,mBAAA;AA8IJ;AA3IE;EACE,mBAAA;AA6IJ;AA1IE;EACE,gBAAA;AA4IJ;AAxII;EACE,kBAAA;AA0IN;AAtIE;EACE,kBAAA;AAwIJ;AArIE;EACE,WAAA;AAuIJ;AApIE;EACE,gBAAA;AAsIJ;;AAlIA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAqIF;AAnIE;EACE,YAAA;EACA,iBAAA;AAqIJ;AAlIE;EACE,mBAAA;AAoIJ;AAjIE;EACE,mBAAA;AAmIJ;;AFjNI;EEmFF;IACE,gBAAA;IACA,cAAA;IACA,eAAA;IACA,aAAA;EAkIF;EAhIE;IACE,2BAAA;IACA,oBAAA;IACA,2BAAA;EAkIJ;EA9HA;IACE,0BAAA;EAgIF;EA7HA;IACE,WAAA;EA+HF;EA5HA;IACE,uBAAA;EA8HF;EA5HE;IACE,eAAA;EA8HJ;EA1HA;IACE,iBAAA;IACA,cAAA;IACA,eAAA;EA4HF;EA1HE;IACE,eAAA;EA4HJ;EAxHA;IACE,iBAAA;IACA,eAAA;EA0HF;EAxHE;IACE,cAAA;EA0HJ;EAvHE;IACE,gBAAA;EAyHJ;AACF;AArHA;EACE,aAAA;AAuHF;;AApHA;EACE,oBAAA;AAuHF;;AApHA;EACE,gBAAA;AAuHF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","// license card component styling\n@import '../../assets/style/mixinfunction';\n\n//license card tile styles start\n\n.user-status {\n  padding: 20px 0 20px;\n  // margin-bottom: 20px;\n  text-align: center;\n\n  i {\n    font-size: 50px;\n    }\n\n  a {\n    align-items: center;\n    display: inline-flex;\n    vertical-align: middle;\n  }\n}\n\nfooter {\n  @include vendor-prefix('border-radius', 0 0 8px 8px);\n  background: color(default, base);\n  bottom: 0;\n  left: 0;\n  padding: 20px;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n}\n\n\n.popup-header {\n  padding: 30px;\n  position: relative;\n\n  h2 {\n    font-size: 30px;\n    font-weight: normal;\n    margin: 0;\n    outline: none;\n    padding: 0;\n    }\n  }\n\n.popup-body {\n  padding: 0 30px 20px;\n\n  hr {\n    margin: 20px 0;\n  }\n\n  h2 {\n    font-size: 30px;\n    margin-bottom: 20px;\n  }\n\n  .current-prod {\n    margin-bottom: 10px;\n  }\n\n  .form-group {\n    margin-bottom: 0;\n  }\n\n  .assign-prod {\n    label {\n      margin-bottom: 5px;\n    }\n  }\n\n  .prod-desc {\n    padding-right: 5px;\n  }\n\n  .new {\n    width: 100%;\n  }\n\n  .text-danger {\n    margin-bottom: 0;\n  }\n}\n\n.popup-footer {\n  border-radius: 8px;\n  bottom: 0;\n  padding: 0 30px;\n  position: relative;\n  width: 100%;\n\n  .btn-click {\n    float: right;\n    margin-left: 30px;\n   }\n\n  hr {\n    margin: 30px 0 20px;\n  }\n\n  a {\n    margin-bottom: 20px;\n  }\n}\n\n@include respond-to (small) {\n  footer {\n    background: none;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 10px;\n\n    button {\n      background: none !important;\n      border: 0 !important;\n      box-shadow: none !important;\n    }\n  }\n\n  .show-sm {\n    border: 1px dashed color(default, dark);\n  }\n\n  .btn {\n    width: 100%;\n  }\n\n  .popup-header {\n    padding: 15px 15px 30px;\n\n    h2 {\n      font-size: 18px;\n    }\n  }\n\n  .popup-body {\n    max-height: 145px;\n    overflow: auto;\n    padding: 0 15px;\n\n    h2 {\n      font-size: 18px;\n    }\n  }\n\n  .popup-footer {\n    background: color(default, light);\n    padding: 0 15px;\n\n    hr {\n      margin: 20px 0;\n    }\n\n    a {\n      margin-top: 20px;\n    }\n  }\n}\n\n.hide {\n  display: none;\n}\n\n.disabled {\n  padding-bottom: 20px;\n}\n\n.on-disable {\n  margin-top: 15px;\n}\n\n// license card tile style end here"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
